/* eslint-disable react/jsx-key */
import React, {useEffect} from 'react';
import Trans from 'next-translate/Trans';
import withTranslation from 'next-translate/withTranslation';
import {withAnalytics} from '../../../modules/analytics/analytics';
import {WithAnalytics} from '../../../lib/analytics/analytics';
// eslint-disable-next-line import/named
import {DefaultTheme} from 'styled-components';
import CommonGlobalStyle from '../../../global-styles/about/about-global-style';
import {NextSeo} from 'next-seo';
import NavBar from '../../../components/nav';
import CommonContentContainer from '../../../components/common/common-content-container';
import CommonBody from '../../../components/common/common-body';
import CommonHeading from '../../../components/common/common-heading';
import {CommonTitle} from '../../../components/common/common-title-subtitle';
import Paragraph from '../../../components/paragraph';
import List from '../../../components/list';
import FonomaAddress from '../../../components/fonoma-address';
import Footer from '../../../components/footer/footer-controller';
import {WithTranslation} from '../../../modules/i18n/i18n-interface';
import {PAGE_EVENTS} from '../../../modules/util/constants';
import {
    GradientBackground,
    GradientType,
} from '../../../components/gradient-background/gradient-background';
import styled from 'styled-components';
import {getLanguageAlternates} from '../../../modules/util/get-alternative-langs-href';
import {getLanguageAwareURL} from '../../../modules/util/get-language-aware-url';

interface TermsPageInitialProps {
    namespacesRequired?: string[];
}

export interface TermsPageProps
    extends WithTranslation,
        WithAnalytics,
        TermsPageInitialProps {
    theme?: DefaultTheme;
}

const Container = styled(CommonContentContainer)`
    color: ${(props): string => props.theme.colors.ballena};
`;

const Body = styled(CommonBody)`
    position: relative;
`;

export function TermsPage(props: TermsPageProps) {
    const {t} = props.i18n;
    const {analytics} = props;

    useEffect(() => {
        void analytics.page(PAGE_EVENTS.TERMS_PAGE);
    });

    return (
        <>
            <CommonGlobalStyle />
            <NextSeo
                title={t('terms:global-title')}
                canonical={getLanguageAwareURL('terms', props.i18n.lang)}
                languageAlternates={getLanguageAlternates('terms')}
            />
            <NavBar />
            <Container>
                <GradientBackground gradient={GradientType.About} />
                <Body>
                    <CommonHeading>{t('terms:global-title')}</CommonHeading>

                    <CommonTitle>
                        {t('terms:general-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        <Trans
                            i18nKey="terms:general-section-paragraph-1"
                            components={[<a href="/privacy"></a>]}
                        />
                    </Paragraph>
                    <Paragraph>
                        {t('terms:general-section-paragraph-2')}
                    </Paragraph>
                    <List>
                        {t('terms:general-section-list-1-item-1')}
                        {t('terms:general-section-list-1-item-2')}
                    </List>
                    <Paragraph>
                        {t('terms:general-section-paragraph-3')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:membership-information-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        <Trans
                            i18nKey="terms:membership-information-section-paragraph-1"
                            components={[<a href="/privacy"></a>]}
                        />
                    </Paragraph>
                    <Paragraph>
                        {t('terms:membership-information-section-paragraph-2')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:unauthorized-use-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:unauthorized-use-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:your-data-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        <Trans
                            i18nKey="terms:your-data-section-paragraph-1"
                            components={[<a href="/privacy"></a>]}
                        />
                    </Paragraph>
                    <Paragraph>
                        {t('terms:your-data-section-paragraph-2')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:your-data-section-paragraph-3')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:your-account-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:your-account-section-paragraph-1')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:your-account-section-paragraph-2')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:your-account-section-paragraph-3')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:refund-policy-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:refund-policy-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:your-obligations-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:your-obligations-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:transactions-on-the-account-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:transactions-on-the-account-section-paragraph-1'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:transactions-on-the-account-section-paragraph-2'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:transactions-on-the-account-section-paragraph-3'
                        )}
                    </Paragraph>

                    <CommonTitle>
                        {t(
                            'terms:third-party-services-and-information-section-title'
                        )}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:third-party-services-and-information-section-paragraph-1'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:third-party-services-and-information-section-paragraph-2'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:third-party-services-and-information-section-paragraph-3'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:third-party-services-and-information-section-paragraph-3'
                        )}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:termination-of-the-agreement-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:termination-of-the-agreement-section-paragraph-1'
                        )}
                    </Paragraph>
                    <List>
                        {t(
                            'terms:termination-of-the-agreement-section-list-1-item-1'
                        )}
                        {t(
                            'terms:termination-of-the-agreement-section-list-1-item-2'
                        )}
                        {t(
                            'terms:termination-of-the-agreement-section-list-1-item-3'
                        )}
                        {t(
                            'terms:termination-of-the-agreement-section-list-1-item-4'
                        )}
                        {t(
                            'terms:termination-of-the-agreement-section-list-1-item-5'
                        )}
                    </List>
                    <Paragraph>
                        {t(
                            'terms:termination-of-the-agreement-section-paragraph-2'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:termination-of-the-agreement-section-paragraph-3'
                        )}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:your-contribution-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:your-contribution-section-paragraph-1')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:your-contribution-section-paragraph-2')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:your-contribution-section-paragraph-3')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:variations-of-the-agreement-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:variations-of-the-agreement-section-paragraph-1'
                        )}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:notices-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:notices-section-paragraph-1')}
                    </Paragraph>
                    <FonomaAddress />
                    <Paragraph>
                        {t('terms:notices-section-paragraph-2')}
                    </Paragraph>

                    <CommonTitle>
                        {t(
                            'terms:use-of-information-and-confidentiality-section-title'
                        )}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:use-of-information-and-confidentiality-section-paragraph-1'
                        )}
                    </Paragraph>
                    <Paragraph>
                        {t(
                            'terms:use-of-information-and-confidentiality-section-paragraph-2'
                        )}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:intellectual-property-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:intellectual-property-section-paragraph-1')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:intellectual-property-section-paragraph-2')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:data-protection-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        <Trans
                            i18nKey="terms:data-protection-section-paragraph-1"
                            components={[<a href="/privacy"></a>]}
                        />
                    </Paragraph>

                    <CommonTitle>
                        {t(
                            'terms:temporary-withdrawal-of-service-section-title'
                        )}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:temporary-withdrawal-of-service-section-paragraph-1'
                        )}
                    </Paragraph>

                    <CommonTitle>{t('terms:agency-section-title')}</CommonTitle>
                    <Paragraph>
                        {t('terms:agency-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:governing-law-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:governing-law-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:severability-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:severability-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>{t('terms:waiver-section-title')}</CommonTitle>
                    <Paragraph>
                        {t('terms:waiver-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:language-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:language-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:definitions-section-title')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:definitions-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:agreement-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:agreement-section-paragraph-1')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:agreement-section-paragraph-2')}
                    </Paragraph>
                    <Paragraph>
                        {t('terms:agreement-section-paragraph-3')}
                    </Paragraph>

                    <CommonTitle>
                        {t(
                            'terms:intellectual-property-rights-section-subtitle'
                        )}
                    </CommonTitle>
                    <Paragraph>
                        {t(
                            'terms:intellectual-property-rights-section-paragraph-1'
                        )}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:privacy-policy-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        <Trans
                            i18nKey="terms:privacy-policy-section-paragraph-1"
                            components={[<a href="/privacy"></a>]}
                        />
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:registration-process-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:registration-process-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:password-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:password-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:recharge-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:recharge-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:services-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:services-section-paragraph-1')}
                    </Paragraph>

                    <CommonTitle>
                        {t('terms:website-section-subtitle')}
                    </CommonTitle>
                    <Paragraph>
                        {t('terms:website-section-paragraph-1')}
                    </Paragraph>
                </Body>
            </Container>
            <Footer />
        </>
    );
}

export default withAnalytics(withTranslation(TermsPage));
